<template>
  <div class="user-cabinet__inner">
    <div class="user-cabinet__area w-95">
      <Alert :variant="variant" v-if="text">{{ text }}</Alert>
      <template v-if="groups.length">
        <div class="user-group__list user-group__grid">
          <ItemGroup v-for="group in groups"
                     :key="group.id"
                     :group="group"
                     :unreadGroups="unreadGroups.find((gr) => gr.id === group.id)"
          />
        </div>
      </template>
      <p v-else-if="groupsLoaded" v-html="content.block[0]"></p>
      <Pagination v-if="pagination.pageCount > 1" :pagination="pagination" @changepage="getGroups" />
    </div>
  </div>
</template>
<script>
import GroupService from '@/services/GroupService';

import ItemGroup from '@/views/profile/MyGroups/ItemGroupV2.vue';
import Alert from '@/components/Alert.vue';
import Pagination from '@/views/profile/MyGroups/Pagination.vue';
import pagination from '@/mixins/pagination';
import exception from '@/mixins/exception';
import content from '@/mixins/content';
import alert from '@/mixins/alert';
import badge from '@/mixins/badge';

export default {
  name: 'MyGroups',
  mixins: [pagination, exception, content, alert, badge],
  components: {
    ItemGroup,
    Alert,
    Pagination,
  },
  data() {
    return {
      groups: [],
      groupsLoaded: false,
    };
  },
  computed: {
    unreadGroups() {
      return this.$store.getters.getUnreadGroups;
    },
  },
  created() {
    if (this.$route.params.type && this.$route.params.type === 'request') {
      this.showAndHideAlertSuccess('You placed request for your group successfully', 'success');
    }

    this.pagination = {
      pageCurrent: +this.$route.query.page || 1,
      pageCount: 1,
      perPage: 5,
      total: 0,
    };
    this.getGroups();
  },
  watch: {
    '$route.query.page': function () {
      this.getGroups();
    },
  },
  methods: {
    async getGroups() {
      try {
        const res = await GroupService.groupsMy({
          page: this.pagination.pageCurrent,
          'per-page': this.pagination.perPage,
        });
        this.groups = res.data;
        this.setPagination(res.headers);
        this.groupsLoaded = true;
      } catch (e) {
        this.handleException(e);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@media (min-width: 768px) and (max-width: 992px) {
  .user-group__grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
